<template>
  <div>
    <BaseDialog
        title="表示項目"
        :visible.sync="dialogVisible"
        width="700px"
        :show-close-icon="false"
        :is-press-escape="false"
        :show-footer="false">
      <template slot="contents">
        <!-- 表示項目 -->
        <div class="dialog-inner">
          <div
              v-for="(item, index) in dialogDisplayConfig"
              :key="index">
            <el-checkbox
                v-model="item.isDisplay"
                :checked="item.isDisplay"
                border>
              {{ item.label }}
            </el-checkbox>
          </div>
        </div>
        <div class="dialog-bottom right">
          <el-button @click="select"> 全選択 </el-button>
          <el-button @click="clear"> クリア </el-button>
          <el-button
              :disabled="isDisable"
              @click="close">
            閉じる
          </el-button>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<style scoped>
.dialog-inner>div {
    display: inline-block;
    margin: 0 10px 10px 0;
}
</style>
<script>

import _ from 'lodash'
import BaseDialog from '@/components/molecules/BaseDialog'
import compareUtils from '@/utils/compareUtils'
import common from '@/utils/common'

export default {
  name: 'BaseDisplaySelectModal',
  components: {
    BaseDialog
  },
  inject: ['parentValidator'],
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    storePath: {
      type: String,
      required: true
    },
    displayConfig: {
      type: Array,
      required: true,
      default: () => []
    },
    tableSetList: {
      type: Array,
      required: true,
      default: () => []
    },
    functionKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      dialogDisplayConfig: []
    }
  },
  computed: {
    isDisable () {
      return this.dialogDisplayConfig
        .filter((data) => data.isDisplay).length === 0
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      this.$emit('update:visible', val)
    },
    tableSetList (val) {
      this.getOptions()
    },
    displayConfig (val) {
      this.getOptions()
    },
    dialogDisplayConfig: {
      handler: function (val, oldVal) {
        if ((oldVal || []).length !== 0) {
          this.$loadingService.show()
        }
        setTimeout(() => {
          this.displayConfig.forEach((data) => {
            const item = val.find((item) => item.itemKey === data.itemKey)
            if (item) data.isDisplay = item.isDisplay
          })
          this.$loadingService.close()
        }, 200)
      },
      deep: true
    }
  },
  methods: {
    close () {
      this.dialogVisible = false
      common.saveDisplay(this.functionKey, this.displayConfig)
    },
    clear: function () {
      this.allDispChange(false)
    },
    // 全選択
    select: function () {
      this.allDispChange(true)
    },
    /**
     * 検索条件の display プロパティを更新します。
     * @param {Boolean} isShow 更新する値
     */
    allDispChange: function (isShow) {
      this.dialogDisplayConfig.forEach((data) => {
        _.set(data, 'isDisplay', isShow)
      })
    },
    getOptions: function () {
      const setVal = this.displayConfig.map((data) => {
        const item = this.tableSetList.find((item) => (item.funcId == null || this.$isFunctionShown(item.funcId)) && item.itemKey === data.itemKey)
        if (!item) return null
        return {
          isDisplay: Boolean(data.isDisplay),
          label: item.label,
          displayOrder: item.displayOrder,
          itemKey: item.itemKey
        }
      }).filter((data) => data !== null)
        .sort((a, b) => a.displayOrder < b.displayOrder ? -1 : 1)

      if (!compareUtils.compare(setVal, this.dialogDisplayConfig)) {
        this.dialogDisplayConfig = setVal
      }
    }
  }
}
</script>
